import React, {Component} from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import {Grid, Dimmer, Loader} from 'semantic-ui-react';
import {dateFormatShow, reverseShortDate} from '../../../common/constants/datesFormat';
import {Actions} from '../../../common/actions';

class Input extends Component {
  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const {chassis} = this.props;
    this.props.fetchInputDataByChassis(chassis);
  };

  componentDidUpdate(prevProps) {
    const {chassis} = this.props;
    if (chassis !== prevProps.chassis) {
      this.fetchData();
    }
  }

  renderLoader = () => {
    const {loading} = this.props;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted content='Consultando...' />
        </Dimmer>
      );
    }
  };

  renderColumn = (width, type, text = '') => {
    if (type === 'label' && !text) {
      return;
    }
    return (
      <Grid.Column width={width}>
        {type === 'label' ? <h4>{text}:</h4> : `${text}`}
      </Grid.Column>
    );
  };

  render() {
    const {inputData} = this.props;
    const liquidationDateFormatted = inputData.liquidationDate ?
      moment(inputData.liquidationDate, reverseShortDate).format(dateFormatShow) : '';
    const boardingDateFormatted = inputData.boardingDate ?
      moment(inputData.boardingDate).format(dateFormatShow) : '';
    const tdeIncomeDateFormatted = inputData.tdeIncomeDate ?
      moment(inputData.tdeIncomeDate).format(dateFormatShow) : '';
    const arrivalDateFormatted = inputData.arrivalDate ?
      moment(inputData.arrivalDate).format(dateFormatShow) : '';

    return (
      <div className='title-bar'>
        {this.renderLoader()}
        <div className='filters-section'>
          <Grid textAlign='left'>
            <Grid.Row>
              {this.renderColumn(2, 'label', 'Pedido')}
              {this.renderColumn(3, 'value', inputData.order)}
              {this.renderColumn(2, 'label', 'Fecha Liquidación')}
              {this.renderColumn(3, 'value', liquidationDateFormatted)}
              {this.renderColumn(2, 'label', 'Fecha Embarque')}
              {this.renderColumn(3, 'value', boardingDateFormatted)}
            </Grid.Row>
            <Grid.Row>
              {this.renderColumn(2, 'label', 'Buque')}
              {this.renderColumn(3, 'value', inputData.vessel)}
              {this.renderColumn(2, 'label', 'Fecha Ingreso TDE')}
              {this.renderColumn(3, 'value', tdeIncomeDateFormatted)}
              {this.renderColumn(2, 'label', 'Fecha Arribo')}
              {this.renderColumn(3, 'value', arrivalDateFormatted)}
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.vehicleHistory.loading,
    'inputData': state.vehicleHistory.inputData,
  };
};

const {fetchInputDataByChassis} = Actions;

export default connect(mapStateToProps, {
  fetchInputDataByChassis,
})(Input);
